<template>
  <div class="wrap">
    <div class="content">
      <el-form :model="dataForm" :rules="rules" label-position="top" ref="dataForm" label-width="180px" class="dataForm">
        <el-divider class="divider" content-position="left">解锁相关</el-divider>
        <el-form-item label="章节解锁最低正确率：" prop="ExamChapterUnlockMinRightRate">
          <el-input v-model="dataForm.ExamChapterUnlockMinRightRate" placeholder="输入章节解锁最低正确率(小数值)，例：0.95=95%"></el-input>
        </el-form-item>
        <el-form-item label="章节解锁提示文案：" prop="ExamChapterUnlockTips">
          <el-input v-model="dataForm.ExamChapterUnlockTips" type="textarea" :autosize="{ minRows: 2, maxRows: 4}" placeholder="输入章节解锁提示文案"></el-input>
        </el-form-item>
        <el-divider class="divider" content-position="left">分享相关</el-divider>
        <el-form-item label="分享标题：" prop="ExamShareTitle">
          <el-input v-model="dataForm.ExamShareTitle"  type="textarea" autosize placeholder="输入题库分享标题"></el-input>
        </el-form-item>
        <el-form-item label="分享副标题：" prop="ExamShareSubTitle">
          <el-input v-model="dataForm.ExamShareSubTitle"  type="textarea" autosize placeholder="输入题库分享标题"></el-input>
        </el-form-item>
        <el-form-item label="分享海报：" prop="ExamSharePoster">
          <el-upload
            class="avatar-uploader"
            :action="imgUploadUrl"
            :headers="uploadHeaders"
            :show-file-list="false"
            :on-success="handleUploadSuccess"
            :before-upload="handleBeforeUpload">
            <img v-if="dataForm.ExamSharePoster" :src="dataForm.ExamSharePoster" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <div class="footer">
          <el-button size="large" @click="configureParse">取消</el-button>
          <el-button size="large" type="primary" @click="saveConfigureAll">更新</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { imgUploadUrl, uploadHeaders } from '@/config/index'
import { configureList, configureCreate, configureUpdate } from '@/api/operation'

export default {
  data() {
    return {
      imgUploadUrl: imgUploadUrl(),
      uploadHeaders: uploadHeaders(),
      dataForm: {
        ExamChapterUnlockMinRightRate: '',
        ExamChapterUnlockTips: '',
        ExamShareTitle: '',
        ExamShareSubTitle: '',
        ExamSharePoster: '',
      },
      configureList: [],
      rules: {
        name: [
          { required: true, message: '请输入VIP产品名称', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请输入VIP产品名称', trigger: 'blur' }
        ],
        price: [
          { required: true, message: '请输入售价', trigger: 'blur' }
        ],
        service_days: [
          { required: true, message: '请输入服务周期', trigger: 'blur' }
        ],
        description: [
          { required: true, message: '请输入VIP产品简介', trigger: 'blur' }
        ],
        detail: [
          { required: true, message: '请输入VIP产品详情描述', trigger: 'blur' }
        ],
        status: [
          { required: true, message: '请选择状态', trigger: 'change' }
        ],
        picture_url: [
          { required: true, message: '请上传主图', trigger: 'change', validator: (rule, value, callback) => {
            if (!this.dataForm.picture_url) {
              return callback(new Error(rule.message))
            } else {
              callback()
            }
          }}
        ]
      }
    }
  },
  created() {
    this.fetchConfigureList()
  },
  mounted() {

  },
  methods: {
    // 配置列表查询
    fetchConfigureList() {
      configureList({codes: JSON.stringify([
        'ExamChapterUnlockMinRightRate', 'ExamChapterUnlockTips',
        'ExamShareTitle', 'ExamShareSubTitle', 'ExamSharePoster'
      ])}).then(res => {
        if (res) {
          this.configureList = res.list
          this.configureParse()
        }
      })
    },
    // 配置列表解析
    configureParse() {
      this.configureList.forEach(v => {
        // 解锁最低正确率
        if (v.code == 'ExamChapterUnlockMinRightRate') {
          this.dataForm.ExamChapterUnlockMinRightRate = v.value
        }
        // 解锁提示
        if (v.code == 'ExamChapterUnlockTips') {
          this.dataForm.ExamChapterUnlockTips = v.value
        }
        // 分享标题
        if (v.code == 'ExamShareTitle') {
          this.dataForm.ExamShareTitle = v.value
        }
        // 分享副标题
        if (v.code == 'ExamShareSubTitle') {
          this.dataForm.ExamShareSubTitle = v.value
        }
        // 分享海报
        if (v.code == 'ExamSharePoster') {
          this.dataForm.ExamSharePoster = v.value
        }
      })
    },
    // 保存所有参数值
    saveConfigureAll() {
      Promise.all([
        this.saveConfigureOne({code: 'ExamChapterUnlockMinRightRate', name: '题库章节解锁最低正确率'}),
        this.saveConfigureOne({code: 'ExamChapterUnlockTips', name: '题库章节解锁提示'}),
        this.saveConfigureOne({code: 'ExamShareTitle', name: '题库分享标题'}),
        this.saveConfigureOne({code: 'ExamShareSubTitle', name: '题库分享副标题'}),
        this.saveConfigureOne({code: 'ExamSharePoster', name: '题库分享海报'})
      ]).then(() => {
        this.$message.success('配置更新成功')
      })
    },
    saveConfigureOne({code, name}) {
      if (this.dataForm[code] === undefined) { return }
      const params = { code: code, name: name, value: this.dataForm[code] }
      const one = this.configureList.find(v => v.code == code)
      // 添加或更新
      one ? configureUpdate(Object.assign({}, params, {id: one.id})) : configureCreate(params)
    },
    handleUploadSuccess(res, file) {
      if (res.code == 0 && res.data) {
        this.dataForm.ExamSharePoster = res.data.url
      } else {
        this.$message.error(res.error)
      }
    },
    handleBeforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 5

      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 5MB!')
      }
      return isLt2M
    },
  }
}
</script>

<style scoped lang="less">
.wrap {
  padding: 0 20px;

  .divider {
    margin-top: 30px;

    .el-divider__text {
      font-weight: normal;
      color: #409EFF;
    }
  }

  .content {
    display: flex;
    // margin-top: 20px;

    .dataForm {
      width: 700px;
    }

    .avatar-uploader /deep/ .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
      border-color: #409EFF;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 178px;
      height: 178px;
      line-height: 178px;
      text-align: center;
    }
    .avatar {
      width: 178px;
      height: 178px;
      display: block;
    }

    .footer {
      display: flex;
      justify-content: center;
    }
  }
}
</style>
